import { useForm } from '@mantine/form';

import { paymentProviderTypes } from '../types';

export type Fields = Pick<
  paymentProviderTypes.PaymentProvider,
  'name' | 'block' | 'department' | 'key'
>;
type PaymentProviderFormProps = {
  initialValues: Fields;
};

export const usePaymentProviderForm = ({ initialValues }: PaymentProviderFormProps) => {
  return useForm({
    initialValues: {
      name: initialValues.name,
      key: initialValues.key,
      block: initialValues.block,
      department: initialValues.department,
    },

    validate: {
      name: (value) => (!value ? 'Name is required' : null),
      key: (value) => (!value ? 'Key is required' : null),
      department: (value) => (!value ? 'Department is required' : null),
    },
  });
};
